// modules
import { handleActions } from 'redux-actions'

// action creators
import {
  setCaseManagersList,
  setCaseManagersListLoader,
  setCaseManagersModalLoader
} from 'src/store/modules/admin/caseManagers'

const initialState = {
  caseManagersList: [],
  loading: false,
  modalLoading: false
}

export default handleActions(
  {
    [setCaseManagersList](state, { payload: caseManagersList }) {
      return {
        ...state,
        caseManagersList
      }
    },
    [setCaseManagersListLoader](state, { payload: loading }) {
      return {
        ...state,
        loading
      }
    },
    [setCaseManagersModalLoader](state, { payload: modalLoading }) {
      return {
        ...state,
        modalLoading
      }
    }
  },
  initialState
)
